export default {
  templateName: { type: 'string', required: true },

  office: { type: 'enum', required: true },
  owner: { type: 'string', required: true },
  section: { type: 'enum', required: true },
  fileType: { type: 'enum', required: true },

  paths: {
    type: 'array',
    maxSize: 1,
    required: true,
  },
};
